import { getMMT_HLD_OBJ } from '../../../common/utils/appUtils';
import {
  CLEAR_ALL_PACKAGES,
  SET_INITIAL_DATA_LOADED,
  SET_LISTING_PACKAGES,
  SET_LISTING_PACKAGES_IS_LOADING,
  SET_PAGE_LOADING,
} from '../constants/listingPackagesConstants';

export const listingPackageInitialState = {
  packagesByGroupId: {},
  isLoading: {},
  pageLoading: true,
  initialDataLoaded: false,
  errorMessage: null,
  fallbackPackages: {
    isLoading: false,
    packageList: [],
    search: null,
  },
};

const listingPackagesReducer = (state = listingPackageInitialState, action) => {
  switch (action.type) {
    case SET_LISTING_PACKAGES: {
      const { groupId, packageDetails, noMorePackages, nextOffset, numFound, errorMessage } =
        action.payload;
      const MMT_HLD = getMMT_HLD_OBJ();
      MMT_HLD.branch = packageDetails?.[0]?.branch;
      return {
        ...state,
        packagesByGroupId: {
          ...state.packagesByGroupId,
          [groupId]: {
            packages: [...(state.packagesByGroupId?.[groupId]?.packages || []), ...packageDetails],
            noMorePackages,
            nextOffset,
            numFound,
            errorMessage,
          },
        },
      };
    }
    case SET_LISTING_PACKAGES_IS_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          ...action.payload,
        },
      };
    case SET_INITIAL_DATA_LOADED:
      return {
        ...state,
        initialDataLoaded: true,
      };
    case SET_PAGE_LOADING:
      return {
        ...state,
        pageLoading: action.payload,
      };
    case CLEAR_ALL_PACKAGES:
      return {
        ...listingPackageInitialState,
      };
    default:
      return state;
  }
};

export default listingPackagesReducer;
